import React from "react";

const ZoomOUT = ({ imageUrl, zoomKey, activeZoom, setActiveZoom }) => {
  const isZoomed = activeZoom === zoomKey;

  const handleImageClick = () => {
    setActiveZoom(isZoomed ? null : zoomKey);
  };

  return (
    <>
      {isZoomed && (
        <div
          onClick={() => setActiveZoom(null)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 9998,
          }}
        />
      )}

      <img
        src={imageUrl}
        alt="Zoomable"
        onClick={handleImageClick}
        style={{
          position: isZoomed ? "fixed" : "static",
          top: isZoomed ? "50%" : "auto",
          left: isZoomed ? "50%" : "auto",
          transform: isZoomed ? "translate(-50%, -50%) scale(2)" : "scale(1)",
          width: isZoomed ? "auto" : "40px",
          height: isZoomed ? "auto" : "40px",
          maxWidth: isZoomed ? "40vw" : "40px",
          maxHeight: isZoomed ? "40vh" : "40px",
          cursor: isZoomed ? "zoom-out" : "zoom-in",
          transition: "transform 0.3s ease",
          display: "block",
          margin: isZoomed ? 0 : "20px auto",
          zIndex: isZoomed ? 9999 : "auto",
          background: isZoomed ? "#000000aa" : "transparent",
          padding: isZoomed ? "10px" : 0,
          borderRadius: "8px",
        }}
      />
    </>
  );
};

export default ZoomOUT;
